export default "__VITE_ASSET__Dk34J_w___"